import { labelOnly } from "../label-only";
import type { ToolActivity } from "../tool-activity";
import type { ToolActivityState } from "../tool-activity-state";

/** The browser tools answer a failure as TEXT, so only `hasFailed` separates
 * "Clicked Log in" from "Could not click Log in". */
export function browserLabel(
  state: ToolActivityState,
  labels: { failed: string; running: string; done: string },
): ToolActivity {
  if (state.hasFailed) return labelOnly(labels.failed);
  return labelOnly(state.isRunning ? labels.running : labels.done);
}
